<template>
  <el-table-column
    prop="shops"
    label="Üzletek"
  >
    <template slot-scope="scope">
      <el-tag v-if="scope.row.shops.length" type="primary"> {{ scope.row.shops.length }} üzlet </el-tag>
      <el-tag v-else type="danger">Nincs Üzlet</el-tag>
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'shops',
  };
</script>
